
export class SubscribersWithDestinedParkAmounts {
  public parkNumber: number;
  public parkDescription: number;
  public subscribersAmount: number;

}
